import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "../utils";

const displayVariants = cva("m-0 font-bold tracking-normal", {
  variants: {
    variant: {
      default: "",
      marketing: ""
    },
    size: {
      xl: "text-8xl leading-29",
      lg: "text-7xl leading-22",
      md: "text-[56px] leading-17",
      sm: "text-5xl leading-14 ",
      xs: "text-[40px] leading-12 tracking-tight"
    }
  },
  compoundVariants: [
    {
      variant: "marketing",
      size: "xl",
      className: "text-8xl leading-24 tracking-tight"
    },
    {
      variant: "marketing",
      size: "lg",
      className: "text-[80px] leading-20 tracking-tight"
    },
    {
      variant: "marketing",
      size: "md",
      className: "text-6xl leading-15 tracking-tight"
    },
    {
      variant: "marketing",
      size: "sm",
      className: "text-5xl leading-12 tracking-tight"
    },
    {
      variant: "marketing",
      size: "xs",
      className: "text-[40px] leading-11 tracking-tight"
    }
  ],
  defaultVariants: {
    variant: "default",
    size: "xl"
  }
});

type DisplayElement = "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";

export interface DisplayProps
  extends React.HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof displayVariants> {
  as?: DisplayElement;
}

const Display = React.forwardRef<HTMLHeadingElement, DisplayProps>(
  ({ className, size, variant, as = "p", ...props }, ref) => {
    const Comp = as;
    return (
      <Comp
        className={cn(displayVariants({ size, variant, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);
Display.displayName = "Display";

export { Display, displayVariants };
